module.exports = __webpack_public_path__ + "img/gywmn4.cbf9c0bf.png";